export const METRICS_DATA = 'CreativeAnalytics.metricsData';